/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import StackGrid from "react-stack-grid";
import mealpic from '../../assets/img/mealtrist-featured-meal.jpg'
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import swal from 'sweetalert';
import MealtristFooter from "../Core/mealtrist-footer";

class Plan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {ingredientAmount: "", measurementTitle: "Unit", groceryItem: "", grocerySpecifics: "", email: "", password: "", planMeals: "", grocery: "", dateMove: 0, selectedDate: "", selectedMeal: "", selectedDay: "", weekTitle: "Current Week", showDays: true, titleEdit: false, grid: "", meals: "", mealsToUpdate: [], mealToMoveClass: "", profile: "", category: "", categoryTitle: "Plan Your Meals - We'll generate a grocery list from your ingredients.", selectedId: 0, parentCategory: "default", parentCategoryId: 0, categoryId: 0, grandParentName: "", grandParentId: 0, savedMeals: "", savedCategories: "", search: "", filterSelect: "All", moveCategory: "Category", moveCategoryId: 0, loggedIn: true, redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleChange = this.handleChange.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.login = this.login.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.onSelectAlert = this.onSelectAlert.bind(this);
        this.selectCategory = this.selectCategory.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.getCategory = this.getCategory.bind(this);
        this.selectToMove = this.selectToMove.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.deletePlanMeal = this.deletePlanMeal.bind(this);
        this.changeToTitleEdii = this.changeToTitleEdii.bind(this);
        this.updateCategoryName = this.updateCategoryName.bind(this);
        this.handleChangeCategoryTitle = this.handleChangeCategoryTitle.bind(this);
        this.deletePlanMealSwal = this.deletePlanMealSwal.bind(this);
        this.resetValue = this.resetValue.bind(this);
        this.getWeek = this.getWeek.bind(this);
        this.changeDate = this.changeDate.bind(this);
        this.getDate = this.getDate.bind(this);
        this.selectDay = this.selectDay.bind(this);
        this.showMeal = this.showMeal.bind(this);
        this.addMealToPlan = this.addMealToPlan.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.onSelectIngredientCategory = this.onSelectIngredientCategory.bind(this);
        this.handleItemChange = this.handleItemChange.bind(this);
        this.handleSpecificsChange = this.handleSpecificsChange.bind(this);
        this.addGroceryItem = this.addGroceryItem.bind(this);
        this.clearGroceryList = this.clearGroceryList.bind(this);
    }

    handleSpecificsChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        this.setState({grocerySpecifics: currentValue });
    }

    handleItemChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        this.setState({groceryItem: currentValue });
    }

    onSelectIngredientCategory(e, event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.getAttribute('data-value');

        this.setState({measurementTitle: currentValue });
    }

    handleAmountChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        var re = /[0-9.]/g;
        var myString = currentValue.match(re);
        var newString = '';
        if (myString && myString.length !== 0) {
            for(var i = 0; i < myString.length; i++) {
                newString += myString[i];
            }
            currentValue = newString;
        } else {
            currentValue = "";
        }

        this.setState({ingredientAmount: currentValue });
    }

    handleChange(event) {
        this.setState({search: event.target.value.toLowerCase()});
    }

    handleChangeCategory(event) {
        this.setState({category: event.target.value.toLowerCase()});
    }

    handleChangeCategoryTitle(event) {
        this.setState({categoryTitle: event.target.value.toLowerCase()});
    }

    changeToTitleEdii(event) {
        this.setState({titleEdit: !this.state.titleEdit});
    }

    onSelectAlert(eventKey) {
        this.setState({filterSelect: eventKey });
    }

    selectCategory(eventKey) {
        this.setState({moveCategory: eventKey[1] });
        this.setState({moveCategoryId: eventKey[0] });
    }

    resetValue(value) {
        if(value === "selectedDate") {
            this.setState({selectedDate: "" });
            this.setState({showDays: true });
        } else if(value === "selectedMeal") {
            this.setState({selectedMeal: "" });
        }
    }

    changeDate(dateNumber) {
        let newDateNumber = this.state.dateMove  + dateNumber;
        let newDateTitle = '';
        if(newDateNumber === 0) {
            newDateTitle = "Current Week";
        } else if(newDateNumber === -7) {
            newDateTitle = "Previous Week";
        } else if(newDateNumber === 7) {
            newDateTitle = "Next Week"
        } else {
            newDateTitle = "Week of ";
        }
        this.setState({weekTitle: newDateTitle});
        this.setState({dateMove: parseInt(newDateNumber) });
    }

    getDate(updateDay) {
        let date = new Date(new Date().setDate(new Date().getDate() + updateDay));
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        return month + "-" + day + "-" + year;
    }

    selectDay(date, day) {
        this.setState({showDays: false });
        this.setState({selectedDate: date });
        this.setState({selectedDay: day });
    }

    showMeal(meal, date) {
        this.setState({selectedMeal: meal });
        console.log("date selected");
        console.log(this.state.selectedDate);
        //do ajax call and get meals
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if (user.token != "") {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if (typeof(response.message) !== 'undefined') {
                        if (response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/plan/meals/show',
                                    type: 'post',
                                    async: false,
                                    data: {
                                        date: date,
                                        course: meal
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        if (typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                planMeals: response.plan
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }

    getWeek(weekNumber, direction) {

    }

    addGroceryItem() {
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if (user.token != "") {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if (typeof(response.message) !== 'undefined') {
                        if (response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/grocery/add',
                                    type: 'post',
                                    async: false,
                                    data: {
                                        amount: globalThis.state.ingredientAmount,
                                        measurement: globalThis.state.measurementTitle,
                                        item: globalThis.state.groceryItem,
                                        specifics: globalThis.state.grocerySpecifics
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        if (typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                grocery: response.grocery
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    clearGroceryList() {
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if (user.token != "") {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if (typeof(response.message) !== 'undefined') {
                        if (response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/grocery/clear',
                                    type: 'post',
                                    async: false,
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        if (typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                grocery: response.grocery
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    addMealToPlan(mealId, course, week, day, date){
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if (user.token != "") {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if (typeof(response.message) !== 'undefined') {
                        if (response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/plan/add',
                                    type: 'post',
                                    async: false,
                                    data: {
                                        dragId: mealId,
                                        dropWeek: week,
                                        dropDay: date,
                                        dropMeal: course
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        if (typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                planMeals: response.plan
                                            }));
                                            globalThis.setState(prevState => ({
                                                grocery: response.grocery
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    updateCategoryName(parentId = 0, parentName = "Default", updatedTitle) {
        console.log(parentId);
        if(parentId > 0) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/saved/category/name',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            parentId: parentId,
                                            parentName: parentName,
                                            title: updatedTitle,
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    categoryTitle: response.title
                                                }));
                                                globalThis.setState(prevState => ({
                                                    titleEdit: false
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    selectToMove(event) {
        let inSavedMeals = null;
        let tempSavedMeals = this.state.mealsToUpdate;
        let allMealsToSave = document.getElementsByClassName('mealToMove');
        let mealId = event.target.getAttribute('data-meal-id');
        if(mealId !== "") {
            inSavedMeals = tempSavedMeals.includes(mealId);
            if(inSavedMeals === false) {
                tempSavedMeals.push(mealId);
                this.setState({password: tempSavedMeals});
            } else {
                if(tempSavedMeals.length > 0)  {
                    var i = tempSavedMeals.indexOf(mealId);
                    if(i != -1) {
                        tempSavedMeals.splice(i, 1);
                    }
                }
            }
            this.setState({mealsToUpdate: tempSavedMeals});
        }
        console.log(this.state.moveCategory);

        //TODO  - SET CLASS FOR ELEMENT AND IF ELEMENT HASCLASS THEN REMOVE CLASS FROM ELEMENT
        event.target.classList.toggle("mealToMove");
        // if(allMealsToSave.length > 0 && typeof(allMealsToSave) === 'object') {
        //     allMealsToSave = Object.entries(allMealsToSave);
        //     console.log(typeof(allMealsToSave));
        //     allMealsToSave.map((meal, mealIndex) => {
        //         console.log(meal);
        //         console.log(meal['1'].getAttribute('data-meal-id'));
        //     });
        // }
    }

    capitalizeWords(str)
    {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    deletePlanMealSwal(mealId, course, week, day, date) {
        swal({
            title: "Are you sure you would like to remove this meal from your plan?",
            buttons: {
                cancel: "Cancel",
                category: {
                    text: "Delete Meal",
                    value: "delPlan",
                }
            },
            dangerMode: true,
            icon: "warning",
        })
            .then((value) => {
                switch (value) {
                    case "delPlan":
                        this.deletePlanMeal(mealId, course, week, day, date);
                        break;

                    default: break;
                }
            });
    }

    deletePlanMeal( mealId, course, week, day, date )
    {
        if(mealId > 0) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/plan/meal/delete',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            delMeal: mealId,
                                            Week: week,
                                            Day: date,
                                            Meal: course
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log("returned");
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    planMeals: response.plan
                                                }));
                                                globalThis.setState(prevState => ({
                                                    grocery: response.grocery
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    updateCategory(cateName, cateId, parentName, parentId, ids = false, moveCategory = null, moveCategoryId = 0)
    {

        if(ids.length > 0) {
            console.log(cateName+ cateId+ parentName+ parentId);
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/saved/update',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName,
                                            savedMeals: JSON.stringify(ids),
                                            moveCategory: moveCategory,
                                            moveCategoryId: moveCategoryId
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));

                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    getCategory(cateName, cateId, parentName, parentId, back = false)
    {
        console.log(cateName+ cateId+ parentName+ parentId);
        if(cateName !== "") {

            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/category/show',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName,
                                            back: back
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                console.log("printing category");
                                                console.log(response.category_parent[0]);
                                                let grandParentCategory = null;
                                                let grandParentCategoryId = null;
                                                let parentCategory = null;
                                                let parentCategoryId = null;
                                                let categoryTitle = null;
                                                if (typeof(response.category_parent) !== 'undefined') {
                                                    if(response.category_parent.constructor === Array) {
                                                        response.category_parent.map((category, cateIndex) => {
                                                            if(cateIndex === 0) {
                                                                if(typeof(category.parent_category) !== "undefined") {
                                                                    grandParentCategory = category.parent_category;
                                                                }
                                                                if(typeof(category.parent_category_id) !== "undefined") {
                                                                    grandParentCategoryId = category.parent_category_id;
                                                                }
                                                                if(typeof(category.category) !== "undefined") {
                                                                    categoryTitle = category.category;
                                                                }
                                                                if(typeof(category.category) !== "undefined") {
                                                                    parentCategory = category.category;
                                                                }
                                                                if(typeof(category.category) !== "undefined") {
                                                                    parentCategoryId = category.id;
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                                if (typeof(response.category) !== 'undefined') {
                                                    if(response.category.constructor === Array) {
                                                        response.category.map((category, cateIndex) => {
                                                            if(cateIndex === 0) {
                                                                if(typeof(category.parent_category) !== "undefined") {
                                                                    parentCategory = category.parent_category;
                                                                }
                                                                if(typeof(category.parent_category_id) !== "undefined") {
                                                                    parentCategoryId = category.parent_category_id;
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                                globalThis.setState(prevState => ({
                                                    savedCategories: response.category
                                                }));
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));
                                                globalThis.setState(prevState =>({
                                                    meals: response.meals
                                                }));
                                                globalThis.setState(prevState => ({
                                                    category: ''
                                                }));
                                                globalThis.setState(prevState => ({
                                                    categoryId: null
                                                }));
                                                globalThis.setState(prevState => ({
                                                    parentCategory: parentCategory
                                                }));
                                                globalThis.setState(prevState => ({
                                                    categoryTitle: categoryTitle
                                                }));
                                                globalThis.setState(prevState => ({
                                                    parentCategoryId: parentCategoryId
                                                }));
                                                // globalThis.setState(prevState => ({
                                                //     categoryTitle: cateName
                                                // }));
                                                globalThis.setState(prevState => ({
                                                    grandParentName: grandParentCategory
                                                }));
                                                globalThis.setState(prevState => ({
                                                    grandParentId: grandParentCategoryId
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    login(e) {
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };

        $.ajax({
            url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/login',
            type: 'post',
            async: false,
            data: {
                email: this.state.email,
                password: this.state.password
            },
            error: function (response) {
                //Failed response
                // logOrderError(visitID, 'otsError', completeOrderData, response);
            },
            success: function (response) {
                console.log(response);
                // this.setState(prevState => ({
                //     redirecting: <Redirect to="/confirmation"/>
                // }));
            }
        });

    }

    createMarkup(text) {
        return {__html: text};
    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        const parentId = this.state.parentCategoryId;
        if(user.token != "" ) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                if (typeof(response.data.id) !== 'undefined') {

                                } else {
                                    globalThis.setState(prevState => ({
                                        loggedIn: false
                                    }));
                                }
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/mealtrist/saves/' + response.data.id,
                                    type: 'post',
                                    async: false,
                                    data: {
                                        parentId: parentId
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response.meals);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                meals: response.meals
                                            }));
                                            globalThis.setState(prevState => ({
                                                profile: response.profile
                                            }));
                                            globalThis.setState(prevState => ({
                                                savedMeals: response.saves
                                            }));
                                            globalThis.setState(prevState => ({
                                                savedCategories: response.category
                                            }));
                                        }
                                    }
                                });

                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/grocery/show',
                                    type: 'post',
                                    async: false,
                                    data: {
                                        parentId: parentId
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response.meals);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                grocery: response.grocery
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }

    }

    //TODO set referrer url link in containers first child link
    render() {
        const grid = {
            update: ""
        }
        const fakeArr = ["d", "a"];
        const pictures = fakeArr.map((imgPath, pathIndex) => {
            return  <div key={imgPath}><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>
        });
        const header = {
            use: ""
        }
        if(this.state.loggedIn === true) {
            header.use = <MealtristHeader/>;
        } else {
            header.use = <MainHeader/>;
        }

        let output =
            <div>
                {header.use}
                <div className="text-center main-body-content">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                </div>
                <MealtristFooter/>
            </div>
        const profile = {
            data: ""
        }
        let planMeals = "";
        let filteredPlans = "";
        let groceryList = "";
        let date = new Date(new Date().setDate(new Date().getDate() + this.state.dateMove));
        let day = date.getDate();
        let dayWeek = date.getDay();
        day = day - dayWeek;
        console.log(this.state.dateMove);
        console.log(dayWeek);
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        date = month + "-" + day + "-" + year;
        let adjustedDateMove = this.state.dateMove - dayWeek;
        let sunday = this.getDate(adjustedDateMove);
        let monday = this.getDate(adjustedDateMove + 1);
        let tuesday = this.getDate(adjustedDateMove + 2);
        let wednesday = this.getDate(adjustedDateMove + 3);
        let thursday = this.getDate(adjustedDateMove + 4);
        let friday = this.getDate(adjustedDateMove + 5);
        let saturday = this.getDate(adjustedDateMove + 6);

        // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date

        let savedCategories = null;
        console.log("print meals first");
        console.log(this.state.meals);
        if(this.state.grocery !== "") {
            groceryList = this.state.grocery.map((item, mealIndex) => {
                let groceryHtml = "";
                let aHtml = "";
                let aAmount = "";
                let bHtml = "";
                let bAmount = "";
                let cHtml = "";
                let cAmount = "";
                if(String(item.amount_a) !== '0') {
                if(item.measurement_a === 'cup') {
                aAmount = Number.parseFloat(item.amount_a / 0.0625).toPrecision(2)
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center" href="#link1" >{aAmount + " cup of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'tablespoon') {
                    aAmount = item.amount_a / 0.00390625;
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " tablespoon of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'teaspoon') {
                    aAmount = Number.parseFloat(item.amount_a / 0.0013020833333333).toPrecision(2);
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " teaspoon of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'quart') {
                    aAmount = Number.parseFloat(item.amount_a / 0.25).toPrecision(2);
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " quart of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'pint') {
                    aAmount = Number.parseFloat(item.amount_a / 0.125).toPrecision(2);
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " pint of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'ounces') {
                    aAmount = Number.parseFloat(item.amount_a / 0.0625).toPrecision(2);
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " ounces of " +item.item}</ReactBootstrap.ListGroupItem>
                } else
                if(item.measurement_a === 'fluid ounce') {
                    aAmount = Number.parseFloat(item.amount_a / 0.0078125).toPrecision(2);
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " fluid ounce of " +item.item}</ReactBootstrap.ListGroupItem>
                } else {
                    aAmount = item.amount_a
                    aHtml = <ReactBootstrap.ListGroupItem key={"planMeala" + 'grocery'+mealIndex} className="text-center">{aAmount + " " + item.measurement_a + " of " +item.item}</ReactBootstrap.ListGroupItem>
                }
                }
                if(String(item.amount_b) !== '0') {
                    if(item.measurement_b === 'cup') {
                        bAmount = Number.parseFloat(item.amount_b / 0.0625).toPrecision(2)
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center" href="#link1" >{bAmount + " cup of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'tablespoon') {
                        bAmount = item.amount_b / 0.00390625;
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " tablespoon of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'teaspoon') {
                        bAmount = Number.parseFloat(item.amount_b / 0.0013020833333333).toPrecision(2);
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " teaspoon of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'quart') {
                        bAmount = Number.parseFloat(item.amount_b / 0.25).toPrecision(2);
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " quart of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'pint') {
                        bAmount = Number.parseFloat(item.amount_b / 0.125).toPrecision(2);
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " pint of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'ounces') {
                        bAmount = Number.parseFloat(item.amount_b / 0.0625).toPrecision(2);
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " ounces of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else
                    if(item.measurement_b === 'fluid ounce') {
                        bAmount = Number.parseFloat(item.amount_b / 0.0078125).toPrecision(2);
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " fluid ounce of " +item.item}</ReactBootstrap.ListGroupItem>
                    } else {
                        bAmount = item.amount_b
                        bHtml = <ReactBootstrap.ListGroupItem key={"planMealb" + 'grocery'+mealIndex} className="text-center">{bAmount + " " + item.measurement_b + " of " +item.item}</ReactBootstrap.ListGroupItem>
                    }
                }

                if(String(item.amount_c) !== '0') {
                    cAmount = item.amount_c
                    cHtml = <ReactBootstrap.ListGroupItem key={"planMealc" + 'grocery'+mealIndex} className="text-center">{cAmount + " " + item.measurement_c + " of " +item.item}</ReactBootstrap.ListGroupItem>
                }
                groceryHtml = <div>
                    {aHtml} {bHtml} {cHtml}
                </div>
                return groceryHtml;
                // return <ReactBootstrap.ListGroupItem key={"planMeal" + 'grocery'+mealIndex} className="text-center" href="#link1" >{groceryHtml + " of " +item.item}</ReactBootstrap.ListGroupItem>
            });
        }
        if(this.state.meals != "" || typeof(this.state.meals) !== 'array') {
            if(this.state.profile != "") {
                profile.data = this.state.profile;
            }
            if(this.state.savedCategories !== "") {
                console.log(this.state.savedCategories);
                savedCategories = this.state.savedCategories.map((category, cateIndex) => {
                    return <div className="col-xm-3" key={category.category+category.id}>
                        <i className="fa fa-folder fa-3x" onClick={this.getCategory.bind(this, category.category, category.id, category.parent_category, category.parent_category_id, false)} aria-hidden="true"></i>
                        <p>{category.category}</p>
                    </div>
                });
            }
            const mealsData = {
                data: ""
            }
            let category_dropdown = null;
            if(this.state.meals.length > 0) {
                let filteredMeals = this.state.meals.filter((meal) => meal.name.toLowerCase().indexOf(this.state.search) > -1);
                console.log(filteredMeals);
                if(this.state.savedMeals !== "") {
                    let mealIds = this.state.savedMeals.map((save, mealIndex) => {
                        return save.meal_id;
                    });
                    console.log(mealIds);
                    //NEED TO FIX THIS AND EXPORT ONLY IDS
                    filteredMeals = filteredMeals.filter((meal) => mealIds.includes(meal.id));
                }
                console.log(filteredMeals);
                if (this.state.filterSelect.toLowerCase() !== "all") {
                    console.log("in first");
                    console.log(this.state.filterSelect);
                    filteredMeals = filteredMeals.filter((meal) => meal.course.toLowerCase().indexOf(this.state.filterSelect) > -1);
                } else {
                    console.log(this.state.filterSelect);
                    console.log("filtered");
                    filteredMeals = filteredMeals.filter((meal) => meal.course !== "");
                }
                console.log(filteredMeals);
                if(this.state.savedCategories !== "" && this.state.mealsToUpdate.length > 0) {
                    console.log(this.state.savedCategories);
                    let get_categories = this.state.savedCategories.map((category, cateIndex) => {

                        return <ReactBootstrap.MenuItem eventKey={[category.id, category.category]}
                                                        onSelect={this.selectCategory}>{category.category}</ReactBootstrap.MenuItem>
                    });
                    let prependGrandParent = "";
                    let prependMain = "";
                    console.log("grandparent id = " + this.state.grandParentId);
                    prependMain = <ReactBootstrap.MenuItem eventKey={[0, "main"]} onSelect={this.selectCategory}>{"main"}</ReactBootstrap.MenuItem>
                    if(this.state.grandParentId != 0) {
                        prependGrandParent = <ReactBootstrap.MenuItem eventKey={[this.state.grandParentId, this.state.grandParentName]} onSelect={this.selectCategory}>{this.state.grandParentName}</ReactBootstrap.MenuItem>;
                    }

                    category_dropdown =<div className="col-sm-12"><div className="col-sm-3"><ReactBootstrap.Form horizontal>
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                            <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.moveCategory)} pullRight id="split-button-pull-right" bsSize="large">
                                {prependMain}
                                {prependGrandParent}
                                {get_categories}
                            </ReactBootstrap.SplitButton>
                        </ReactBootstrap.FormGroup>
                    </ReactBootstrap.Form>
                    </div>
                        <div className="col-xs-3">
                            <ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.Button bsSize="large" onClick={this.updateCategory.bind(this, this.state.category, this.state.categoryId, this.state.parentCategory, this.state.parentCategoryId, this.state.mealsToUpdate, this.state.moveCategory, this.state.moveCategoryId)}>Move Meals</ReactBootstrap.Button>
                            </ReactBootstrap.ButtonToolbar>
                        </div>
                    </div>
                } else {
                    category_dropdown = "";
                }
                mealsData.data = filteredMeals.map((meal, mealIndex) => {
                    return <ReactBootstrap.ListGroupItem key={mealIndex} className="text-center" href="#link1" onClick={this.addMealToPlan.bind(this, meal.id, this.state.selectedMeal, this.state.dateMove, this.state.selectedDay, this.state.selectedDate)}>{meal.name}</ReactBootstrap.ListGroupItem>
                });

                if(this.state.planMeals && this.state.planMeals !== "") {
                    filteredPlans = this.state.planMeals.filter((meal) => (meal.day === this.state.selectedDate && meal.meal === this.state.selectedMeal) );
                    planMeals = filteredPlans.map((meal, mealIndex) => {
                        return <div className="row">
                            <div className="col-sm-8">
                        <ReactBootstrap.ListGroupItem key={"planMeal" + mealIndex} className="text-center" ><Link to={'meal-show/' + meal.meal_id}>{meal.name}</Link>
                                </ReactBootstrap.ListGroupItem>
                            </div>
                            <div className="col-sm-4"><i className="fa fa-trash fa-2x" onClick={this.deletePlanMealSwal.bind(this, meal.id, this.state.selectedMeal, this.state.dateMove, this.state.selectedDay, this.state.selectedDate)}></i></div>
                            </div>
                    });
                }
            }
            let back = "";
            if(this.state.parentCategory !== "default") {
                back = <i className="fa fa-reply fa-2x" onClick={this.getCategory.bind(this, this.state.grandParentName, this.state.grandParentId, this.state.grandParentName, this.state.grandParentId, "back")}></i>
            }

            let dateDayBack = "";
            if(this.state.selectedDate !== "" && this.state.selectedMeal === "") {
                dateDayBack = <i className="fa fa-reply fa-2x" onClick={this.resetValue.bind(this, "selectedDate", "showDays")}></i>
            }
            if(this.state.selectedMeal !== "") {
                dateDayBack = <i className="fa fa-reply fa-2x" onClick={this.resetValue.bind(this, "selectedMeal")}></i>
            }

            let ingredientForm = "";
            ingredientForm =  <div>
                <br></br>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientAmount">
                                <ReactBootstrap.FormControl type="text" data-id="itemAmount" value={this.state.ingredientAmount} onChange={this.handleAmountChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Amount" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientMeasurement">
                                <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.measurementTitle)} pullRight id="split-button-pull-right" bsSize="large">
                                    <ReactBootstrap.MenuItem data-id="measurement1" data-value="unit" onSelect={this.onSelectIngredientCategory}>Package/Unit(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement2" data-value="teaspoon" onSelect={this.onSelectIngredientCategory}>Teaspoon(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement3" data-value="tablespoon" onSelect={this.onSelectIngredientCategory}>Tablespoon(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement4" data-value="cup" onSelect={this.onSelectIngredientCategory}>Cup(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement5" data-value="pound" onSelect={this.onSelectIngredientCategory}>Pound(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement6" data-value="ounces" onSelect={this.onSelectIngredientCategory}>Ounce(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement7" data-value="fluid ounce" onSelect={this.onSelectIngredientCategory}>Fluid Ounce(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement8" data-value="pint" onSelect={this.onSelectIngredientCategory}>Pint(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement9" data-value="quart" onSelect={this.onSelectIngredientCategory}>Quart(s)</ReactBootstrap.MenuItem>
                                    <ReactBootstrap.MenuItem data-id="measurement10" data-value="gallon" onSelect={this.onSelectIngredientCategory}>Gallon(s)</ReactBootstrap.MenuItem>
                                </ReactBootstrap.SplitButton>
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientItem">
                                <ReactBootstrap.FormControl type="text" data-id="groceryItem" value={this.state.groceryItem} onChange={this.handleItemChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Item" />
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-3 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formIngredientAmount">
                                <ReactBootstrap.FormControl type="text" data-id="grocerySpecifics" value={this.state.grocerySpecifics} onChange={this.handleSpecificsChange}
                                                            onKeyUp={this.handleKeyUp} placeholder="Specifics" />
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
            </div>

            output = <div>
                <div className="container main-body-content">
                    {header.use}

                    <div classNmae="row">
                        <div className="col-sm-6 col-sm-push-6">
                            <div className="col-sm-12">
                                {this.state.showDays === true &&
                                    <div>
                                <div className="pull-left">
                                <i className="fa fa-arrow-left fa-3x" onClick={this.changeDate.bind(this, -7)}></i>
                            </div>
                            <div className="pull-right">
                                <i className="fa fa-arrow-right fa-3x" onClick={this.changeDate.bind(this, 7)}></i>
                            </div>
                                <h3 className="text-center">{this.state.weekTitle}
                                    {this.state.dateMove !== 0 && this.state.dateMove !== -7 && this.state.dateMove !== 7 &&
                                        date
                                    }
                                </h3>
                                    </div>
                                }
                                {this.state.showDays === false &&
                                    <div>
                                <h2 className="text-center">{this.state.weekTitle}
                                    {this.state.dateMove !== 0 && this.state.dateMove !== -7 && this.state.dateMove !== 7 &&
                                    date
                                    }
                                </h2>
                                <h3 className="text-center">{this.state.selectedDay}</h3>
                                    </div>
                                }
                            </div>
                            <div className="col-sm-12">
                                {this.state.showDays === true &&
                                    <div>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, sunday, "Sunday")}>Sunday {sunday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, monday, "Monday")}>Monday {monday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, tuesday, "Tuesday")}>Tuesday {tuesday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, wednesday, "Wednesday")}>Wednesday {wednesday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, thursday, "Thursday")}>Thursday {thursday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, friday, "Friday")}>Friday {friday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.selectDay.bind(this, saturday, "Saturday")}>Saturday {saturday}</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                    </div>
                                }

                                {(this.state.selectedDate !== "" && this.state.selectedMeal === "") &&
                                    <div>
                                        {dateDayBack}
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.showMeal.bind(this, "breakfast", this.state.selectedDate)}>Breakfast</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.showMeal.bind(this, "lunch", this.state.selectedDate)}>Lunch</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.showMeal.bind(this, "dinner", this.state.selectedDate)}>Dinner</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                                    </div>
                                }

                                {this.state.selectedMeal !== "" &&
                                    <div>
                                        {dateDayBack}
                                    <h3>Select a saved meal to add here</h3>
                                        {planMeals}
                                    </div>
                            }
                                    </div>
                        </div>
                        <div className="col-sm-6 col-sm-pull-6">
                            {this.state.parentCategory !== "default" &&
                            <div className="row">
                            <div className="col-sm-9">
                                {back}
                            </div>
                            </div>
                            }
                            {(this.state.titleEdit === false && this.state.parentCategory !== "default") &&
                            <h2 className="text-center" onClick={this.changeToTitleEdii}>{this.state.categoryTitle}</h2>
                            }
                            {(this.state.titleEdit === false && this.state.parentCategory === "default") &&
                            <h2 className="text-center">{this.state.categoryTitle}</h2>
                            }
                        <StackGrid
                            columnWidth={"25%"}
                            monitorImagesLoaded="{true}"
                            // duration={0}
                        >
                            {savedCategories}

                        </StackGrid>
                            <h3 className="text-center">Uncategorized Meals</h3>
                            <div className="row">
                                <div className="col-xs-6">
                                    <ReactBootstrap.Form horizontal>
                                        <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalSearch">
                                            <ReactBootstrap.FormControl type="text" value={this.state.search} onChange={this.handleChange} placeholder="Search Meals" />
                                        </ReactBootstrap.FormGroup>
                                    </ReactBootstrap.Form>
                                </div>
                                <div className="col-xs-6">
                                    <ReactBootstrap.Form horizontal>
                                        <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                            <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.filterSelect)} pullRight id="split-button-pull-right" bsSize="large">
                                                <ReactBootstrap.MenuItem eventKey={'all'} onSelect={this.onSelectAlert}>All</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="main dishes" onSelect={this.onSelectAlert}>Main Dishes</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="appetizer" onSelect={this.onSelectAlert}>Appetizer</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="beverages" onSelect={this.onSelectAlert}>Beverages</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="breads" onSelect={this.onSelectAlert}>Breads</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="desserts" onSelect={this.onSelectAlert}>Desserts</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="finger foods" onSelect={this.onSelectAlert}>Finger Foods</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="salads" onSelect={this.onSelectAlert}>Salads</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="side dishes" onSelect={this.onSelectAlert}>Side Dishes</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="snacks" onSelect={this.onSelectAlert}>Snacks</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem eventKey="soups and stew" onSelect={this.onSelectAlert}>Soups & Stew</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem divider />
                                                <ReactBootstrap.MenuItem eventKey="4">Separated link</ReactBootstrap.MenuItem>
                                            </ReactBootstrap.SplitButton>
                                        </ReactBootstrap.FormGroup>
                                    </ReactBootstrap.Form>
                                </div>
                            </div>
                            <div className="row">
                                <h2 className="text-center">Click meal pictures in order to mark them and move to another folder.</h2>
                                {this.state.mealsToUpdate.length > 0 &&
                                <h2 className="text-center">Choose a category you would like to move meals into.</h2>
                                }
                                {category_dropdown}
                            </div>
                            <ReactBootstrap.ListGroup>
                                {mealsData.data}
                            </ReactBootstrap.ListGroup>
                        </div>
                        <div className="col-sm-12">
                            <br></br>
                            <h2 className="text-center">Add to shopping list</h2>
                            {ingredientForm}
                            <ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.Button bsSize="large" onClick={this.addGroceryItem}>Add Item</ReactBootstrap.Button>
                            </ReactBootstrap.ButtonToolbar>
                            <br></br>
                            <ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.Button bsSize="large" onClick={this.clearGroceryList}>Clear Grocery List</ReactBootstrap.Button>
                            </ReactBootstrap.ButtonToolbar>
                        </div>
                        <div className="col-sm-12">
                            <ReactBootstrap.ListGroup>
                                {groceryList}
                            </ReactBootstrap.ListGroup>
                        </div>
                    </div>

                </div>
                <MealtristFooter/>
            </div>
        }
        // console.log("print grid");
        // console.log(grid.update);
        // if(grid.update !== "") {
        //     console.log("grid updating");
        //     console.log(grid.update);
        //     grid.update.updateLayout();
        // }
        return (

            output

        );
    }
}

export default Plan;


// WEBPACK FOOTER //
// ./src/components/Mealtrist/plan.js